var TriListVilla = {


	init:function(){
		console.log("________TRI LIST VILLA___________");

		$(".region-select select").change(function(){
			
			console.log("SELECT CHANGE : " + $(this).val());
			
			TriListVilla.new_tri( $(this).val());
		});
	},
	new_tri:function(pValue){
		console.log("NEW TRI VILLA : " + pValue);

		var _item_founds = 0;
		
		if(pValue == "all"){
			
			_item_founds = 1;
			
			$(".region-select .select-items div:first-child").html("Choisissez dans la liste");
			$(".region-select select option:first-child").html("Choisissez dans la liste");
			
			$(".tease-villa").each(function(){
				$(this).removeClass("hidden");
			});
		}else{

			
			$(".region-select .select-items div:first-child").html("Toutes les régions");
			$(".region-select select option:first-child").html("Toutes les régions");
			
			$(".tease-villa").each(function(){

				if($(this).attr("data-region") == pValue){
					$(this).removeClass("hidden");
					_item_founds ++;
				}else{
					$(this).addClass("hidden");
				}
			});

		}
		
		console.log("TRI DONE ! NB ITEMS FOUND : " + _item_founds );
		
		if(_item_founds == 0){
			$(".villa-no-results").addClass("visible");
			var __decal =-1 * ($(window).innerHeight() / 2);
		}else{
			$(".villa-no-results").removeClass("visible");
			var __decal = 0;
		}
		
		$('html, body').animate({scrollTop:$(".block-liste-villas").offset().top + __decal}, 500);

	}
}